import { Configuration, LogLevel } from '@azure/msal-browser'
import { logger } from 'app/logging/Logger'

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.CLIENT_ID,
        authority: process.env.AUTHORITY,
        redirectUri: `${window.location.origin}/authenticated/`,
        postLogoutRedirectUri: `${window.location.origin}/login/`,
        navigateToLoginRequestUrl: false,
        knownAuthorities: [process.env.KNOWN_AUTHORITY],
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (
                level: LogLevel,
                message: string,
                containsPii: boolean
            ) => {
                if (containsPii) {
                    return
                }
                switch (level) {
                    case LogLevel.Error:
                        logger.error(message, new Error(message), {
                            action: 'msal_error',
                        })
                        return
                    case LogLevel.Warning:
                        logger.warn(message, {
                            action: 'msal_warning',
                        })
                        return
                    default:
                        return
                }
            },
        },
    },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 */
export const loginRequest = {
    scopes: [process.env.CLIENT_ID],
}
